export default {"src":"/_next/static/media/assistant-cleaner.ffbd1ca2.svg","height":313,"width":368};